import React, { useState, useEffect} from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { MessageBar, MessageBarType, PrimaryButton, Icon } from '@fluentui/react';
import { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';
import Api from '../../services/Api'
import MasterDataManagersItem from './MasterDataManagersItem';
import { groupBy } from '../../helpers/HelperMethods';

const MasterDataManagers = ({getEndpoint, saveEndpoint, depth, onItemNameRender, groupByProperty, keyProperty, onHeaderNameRender}) => {
    
    const [isLoading, setLoading] = useState(false);
    const [allMasterData, setAllMasterData] = useState({});
    const [masterData, setMasterData] = useState([]);
    const [managers, setManagers] = useState({});
    const [message, setMessage] = useState();
    const [isSaving, setSaving] = useState(false);
    const [showGroup, setShowGroup] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            await getManagers();
        }
        fetchData();
    }, []);

    const getManagers = async () => {
        setLoading(true);
        try {
            const res = await Api.get(getEndpoint);
            const data = res.data;

            const masterData = depth ? data.filter(x => x.depth === depth) : data;

            const users = data.reduce((managers, t) => {
                return {
                    ...managers,
                    [t.id]: t.managers.map(u => mapDbUserForPeoplePicker(u))
                }
            }, []);

            setAllMasterData(data.reduce((accumulator, currentValue) => { return {...accumulator, [currentValue[keyProperty]]: currentValue}}, {}));
            setMasterData(masterData);
            setManagers(users);

            setLoading(false);
        }
        catch(error) {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get Managers settings from database: ' + error
            });
        }
    }

    const saveSettings = async () => {
        setSaving(true);
        setMessage();
        
        try {
            const res = await Api.post(saveEndpoint, managers);
            const post = res.status;

            if(post === 200) {
                setSaving(false);
                setMessage({
                    type: MessageBarType.success,
                    text: 'Settings have been saved.'
                });
            } else {
                setSaving(false);
                setMessage({
                    type: MessageBarType.error,
                    text: 'Cannot save settings: ' + post.message
                });
            }
        } catch(error) {
            setSaving(false);
            console.log(error);
        };
    }

    const onSelectedUsers = (id, newUsers) => {
        const u = {
            ...managers,
            [id]: newUsers
        }
        setManagers(u);
    }

    const msg = message && 
                <MessageBar messageBarType={message.type}>
                    {message.text}
                </MessageBar>

    const groupedMasterData = groupBy(masterData, groupByProperty);

    const items = Object.keys(groupedMasterData).sort().map((x, index) => 
                    <div key={index} style={containerStyles}>
                        <div style={headerStyles} onClick={() => setShowGroup({...showGroup, [x]: !showGroup[x]})}>
                            <Icon iconName={showGroup[x] ? 'ChevronUp' : 'ChevronDown'} style={iconStyles}/> 
                            {onHeaderNameRender(allMasterData[x])}
                        </div>
                        {
                            showGroup[x] &&
                            <div style={itemsStyles}>
                            {
                                groupedMasterData[x].sort((a, b) => a.key > b.key ? 1 : -1 ).map(t => {
                                    return <MasterDataManagersItem
                                        key={t.id} 
                                        name={onItemNameRender(t)} 
                                        managers={t.managers}
                                        onSelectedUsers={(users) => onSelectedUsers(t.id, users)} 
                                    />
                                })
                            }
                            </div>
                        }
                    </div>
                )
    
    const btn = isSaving
                ? <Spinner className='settings-btn' size={SpinnerSize.large} />
                : <PrimaryButton className='settings-btn' onClick={saveSettings}>Save</PrimaryButton>

    return (
        <div>
            {isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div className='settings-container'>
                    {items}
                    {btn}
                    {msg}
                </div>
            }
        </div>
    );
}
const iconStyles = {
    verticalAlign: 'middle',
    marginRight: 10
}

const containerStyles = {
    margin: '0 20px 20px 10px',
}

const headerStyles = {
    fontSize: 18,
    cursor: 'pointer'

}
const itemsStyles = {
    margin: '20px 0 0 29px',
}


export default MasterDataManagers;



// WEBPACK FOOTER //
// ./src/components/Settings/MasterDataManagers.js